import axios from "axios";

let cachedResponses = null;
let fetchPromise = null;

/**
 * Fetches canned responses once and caches them for the session.
 * Subsequent calls return the cached result instantly.
 *
 * @returns {Promise<string[]>} Array of canned response text strings
 */
export async function getCannedResponses() {
  if (cachedResponses !== null) {
    return cachedResponses;
  }

  // Deduplicate concurrent requests
  if (fetchPromise) {
    return fetchPromise;
  }

  fetchPromise = (async () => {
    try {
      const response = await axios.get("/api/Snippet/CannedResponses");
      if (response.data?.success && response.data.data) {
        cachedResponses = response.data.data.map((item) => item.text);
      } else {
        cachedResponses = [];
      }
    } catch (error) {
      console.error("Failed to load canned responses", error);
      cachedResponses = [];
    } finally {
      fetchPromise = null;
    }
    return cachedResponses;
  })();

  return fetchPromise;
}

/**
 * Clears the cached responses, forcing a fresh fetch on next call.
 */
export function clearCannedResponsesCache() {
  cachedResponses = null;
}
